import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

export function setupI18n(options = { locale: 'en', warnHtmlMessage: false }) {
    const i18n = createI18n(options);
    setI18nLanguage(i18n, options.locale);
    return i18n;
}

export function setI18nLanguage(i18n, locale) {
    if (i18n.mode === 'legacy') {
        i18n.global.locale = locale;
    } else {
        i18n.global.locale.value = locale;
    }

    // Set <html lang="xx">
    document.querySelector('html').setAttribute('lang', locale);

    /**
     * NOTE:
     * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
     * Example for axios:
     * axios.defaults.headers.common['Accept-Language'] = locale;
     */
}

export async function loadLocaleMessages(i18n, fallbackLang = 'en') {
    const res = await axiosBase.get('lang-trans');
    await setLangsLocaleMessage(res, i18n, fallbackLang);
}

export function setLangsLocaleMessage(res, i18n, fallbackLang = 'en') {
    const messages = {};

    res.data.data.forEach((lang) => {
        messages[lang.key] = {};

        lang.translations.forEach((translation) => {
            if (!messages[lang.key][translation.group]) {
                messages[lang.key][translation.group] = {};
            }
            messages[lang.key][translation.group][translation.key] = translation.value;
        });
        console.log(`🌐 Setting locale messages for [${lang.key}]:`, messages);

        // Register this language in i18n
        i18n.global.setLocaleMessage(lang.key, messages[lang.key]);
    });
    console.log("✅ All locale messages set:", i18n.global.availableLocales);

    // Set fallback/default language
    if (fallbackLang) {
        if (i18n.mode === 'legacy') {
            i18n.global.locale = fallbackLang;
        } else {
            i18n.global.locale.value = fallbackLang;
        }
        document.querySelector('html').setAttribute('lang', fallbackLang);
    }

    return nextTick();
}
